import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function usePostBulkUploadEmployees(
  closeModal,
  isModalOpen = true
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.BULK_UPLOAD_EMPLOYEE_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data?.message });
        if (isModalOpen) {
          closeModal();
        }
        queryClient.invalidateQueries('get-all-team-members');
        queryClient.invalidateQueries('get-all-employees-data');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
